export default __webpack_public_path__ + "static/media/feature-image5.77176ca8.png";